<template>
  <div v-if="licenseSpecification" v-loading="!licenseSpecification">
    <h1 class="fla__title">{{ license.title }}</h1>

    <div class="fla__body">
      <div
        class="license-renderer"
        v-for="specification in licenseSpecification"
        :id="specification.id"
        :key="specification.id"
        v-if="!licenseRendererHideFlag[specification.id]"
      >

        <h2 v-if="specification.title">{{ specification.title }}<small v-if="specification.optional"> (Optional)</small></h2>

        <CommonLicenseComponents
          ref="CommonLicenseComponents"
          class="license-renderer__common-license-components"
          v-for="(item, itemIndex) in specification.items"
          :key="`${specification.id}-${itemIndex}`"

          :licenseRendererVm="thisComponent"
          :licenseWrapper="specification"
          :licenseItem="item"
          v-bind="form[specification.id]"
          @input="([fieldName, fieldValue]) => $emit('input', [fieldName, fieldValue])"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CommonLicenseComponents from './';

export default {
  components: {
    CommonLicenseComponents,
  },
  props: {
    licenseName: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      thisComponent: this,
      componentReference: {},
      licenseRendererHideFlag: {},
    };
  },
  computed: {
    agreement() {
      return this.$store.state.agreement;
    },
    license() {
      return this.agreement.specification[this.licenseName] || null;
    },
    licenseSpecification() {
      if (!this.license) return null;

      return this.license.sequence
        .map((licenseItemName) => {
          const agreementItem =
            this.agreement.action[licenseItemName] ||
            this.agreement.license[licenseItemName] ||
            null;

          if (agreementItem) agreementItem.id = licenseItemName;
          return agreementItem;
        })
        .filter(item => item != null);
    },
  },
  methods: {
    addReference(name, vm) {
      this.$set(this.componentReference, name, vm);
    },
    hideLicenseRenderer(specificationId, shouldHide) {
      this.$set(this.licenseRendererHideFlag, specificationId, shouldHide);
    },
  },
};
</script>

<style lang="scss" scoped>
.license-renderer {
  margin-bottom: 48px;
}
.license-renderer__common-license-components {
  margin-top: 8px;
  margin-bottom: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/Licenses/CommonLicenseComponents/LicenseRenderer.vue